import { type WorkoutItemGroupType } from "api-client/legacy-trpc";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui";

import { type TranslationKey } from "src/types";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";

import { SectionFieldRow } from "./SectionFieldRow";

interface SectionTypeFieldProps {
  value: WorkoutItemGroupType | null;
  onChange: (value: WorkoutItemGroupType) => void;
}

const SECTION_TYPE_OPTIONS: Array<{
  value: WorkoutItemGroupType;
  labelKey: TranslationKey;
}> = [
  { value: "WARM_UP", labelKey: "editWorkout.sectionType.warmup" },
  { value: "WORKOUT", labelKey: "editWorkout.sectionType.workout" },
  { value: "COOLDOWN", labelKey: "editWorkout.sectionType.cooldown" },
  { value: "RECOVERY", labelKey: "editWorkout.sectionType.recovery" },
];

export function SectionTypeField(props: SectionTypeFieldProps) {
  const { t } = useTranslation();
  const permissions = useWorkoutPermissions();

  return (
    <SectionFieldRow
      label={t("editWorkout.sectionType.label")}
      renderField={(id) => {
        return (
          <Select
            value={props.value || "WORKOUT"}
            disabled={!permissions.canEditItems}
            onValueChange={(value) => {
              props.onChange(value as WorkoutItemGroupType);
            }}
          >
            <SelectTrigger
              id={id}
              className="!h-7 min-h-0 text-sm bg-white/80 border-slate-200 w-[105px] px-2 py-0"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {SECTION_TYPE_OPTIONS.map((option) => {
                return (
                  <SelectItem key={option.value} value={option.value}>
                    {t(option.labelKey)}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
        );
      }}
    />
  );
}
